import { postCall, getCall, putCall } from "./api";

// Leave Type

export const createLeaveType = async (input = {}) => {
  return await postCall({ path: `/leave-type`, bodyParams: input, });
};

export const getAllLeaveType = async () => {
  return await getCall({ path: `/leave-type`, });
};

export const getLeaveTypeById = async (id) => {
  return await getCall({ path: `/leave-type/${id}`, });
};

export const updateLeaveType = async (id, input = {}) => {
  return await putCall({ path: `/leave-type/${id}`, bodyParams: input, });
};

// Leave Request

export const leaveRequest = async (input = {}) => {
    return await postCall({ path: `/leave-request`, bodyParams: input, });
};

// the logged-in employee's own leave requests (not the whole org)
export const getleaveDetails = async () => {
  return await getCall({ path: `/leave-request/self`, });
};

export const getAllLeaveRequests = async () => {
  return await getCall({ path: `/leave-request`, });
};

//  get leave request by id

export const getLeaveRequestById = async (leaveId) => {
  return await getCall({ path: `/leave-request/${leaveId}`, });
};

//review leave request
export const reviewLeaveRequest = async (input = {}, id) => {
  return await postCall({ path: `/leave-request/${id}/review`, bodyParams: input, });
};

/**
 * Call off approved leave that has not started. Not a rejection: the days go
 * back to the employee's balance, which a rejection never does because it never
 * took them.
 */
export const cancelLeaveRequest = async (id, input = {}) => {
  return await postCall({ path: `/leave-request/${id}/cancel`, bodyParams: input });
};

// Leave Policy

export const createLeavePolicy = async (input = {}) => {
    return await postCall({ path: `/leave-policy`, bodyParams: input, });
  };
  
  export const getAllLeavePolicy = async () => {
    return await getCall({ path: `/leave-policy`, });
  };

  // logged-in employee's leave balances: [{ leaveType, quantity, ... }]
  export const getSelfLeaveBalance = async () => {
    return await getCall({ path: `/leave-policy/self-balance`, });
  };

  // a specific employee's leave balances (admin profile view)
  export const getLeaveBalanceByEmployee = async (employeeId) => {
    return await getCall({ path: `/leave-policy/balance/${employeeId}`, });
  };

  // leave requests filtered to one employee (admin profile view)
  export const getLeaveRequestsByEmployee = async (employeeId) => {
    return await getCall({ path: `/leave-request?employeeId=${employeeId}`, });
  };

  export const getLeavePolicyById = async (id) => {
    return await getCall({ path: `/leave-policy/${id}`, });
  };

  export const updateLeavePolicy = async (id, input = {}) => {
    return await putCall({ path: `/leave-policy/${id}`, bodyParams: input, });
  };

  // publish a draft leave policy: activate + credit all assigned employees
  export const publishLeavePolicy = async (id) =>
    await postCall({ path: `/leave-policy/${id}/publish`, bodyParams: {} });

  // team leave calendar — who's off (approved/pending) in a window
  export const getLeaveCalendar = async ({ from, to, department, status, employee } = {}) => {
    const qs = new URLSearchParams();
    if (from) qs.set("from", from);
    if (to) qs.set("to", to);
    if (department) qs.set("department", department);
    if (status) qs.set("status", status);
    if (employee) qs.set("employee", employee);
    return await getCall({ path: `/leave-request/calendar?${qs.toString()}` });
  };

  // Leave ledger (credit/debit history behind a balance).
  // from/to are ISO date strings; type is ACCRUAL | LEAVE_TAKEN | ENCASHMENT | ADJUSTMENT.
  export const getLeaveTransactions = async ({ employee, leaveType, type, from, to, limit, skip } = {}) => {
    const qs = new URLSearchParams();
    if (employee) qs.set("employee", employee);
    if (leaveType) qs.set("leaveType", leaveType);
    if (type) qs.set("type", type);
    if (from) qs.set("from", from);
    if (to) qs.set("to", to);
    if (limit) qs.set("limit", limit);
    if (skip) qs.set("skip", skip);
    return await getCall({ path: `/leave-transaction?${qs.toString()}` });
  };

  // Org-wide roll-up: movements in the window, outstanding liability by leave
  // type, and a count of balances the ledger cannot account for.
  export const getLeaveSummary = async ({ from, to } = {}) => {
    const qs = new URLSearchParams();
    if (from) qs.set("from", from);
    if (to) qs.set("to", to);
    return await getCall({ path: `/leave-transaction/summary?${qs.toString()}` });
  };

  // Monthly movements plus the running liability — days owed at each month end.
  export const getLeaveTrend = async ({ months } = {}) => {
    const qs = new URLSearchParams();
    if (months) qs.set("months", months);
    return await getCall({ path: `/leave-transaction/trend?${qs.toString()}` });
  };

  // Opening / accrued / taken / encashed / adjusted / closing per leave type.
  // Omit `month` for a whole-year statement.
  export const getLeaveStatement = async (employeeId, { year, month } = {}) => {
    const qs = new URLSearchParams();
    if (year != null) qs.set("year", year);
    if (month != null) qs.set("month", month);
    const who = employeeId || "self";
    return await getCall({ path: `/leave-transaction/statement/${who}?${qs.toString()}` });
  };

  //add and remove departments to leave policy
  export const addDepartmentsToLeavePolicy = async (policyId, input = {}) => {
    return await postCall({ path: `/leave-policy/${policyId}/departments-add`, bodyParams: input, });
  };

  export const removeDepartmentsFromLeavePolicy = async (policyId, input = {}) => {
    return await postCall({ path: `/leave-policy/${policyId}/departments-remove`, bodyParams: input, });
  };

  //add and remove groups from leave policy
  export const addGroupsToLeavePolicy = async (policyId, input = {}) => {
    return await postCall({ path: `/leave-policy/${policyId}/groups-add`, bodyParams: input, });
  };

  export const removeGroupsFromLeavePolicy = async (policyId, input = {}) => {
    return await postCall({ path: `/leave-policy/${policyId}/groups-remove`, bodyParams: input, });
  };
  
// leave raised by the caller's direct reports (empty for non-managers)
export const getTeamLeaveRequests = async (status) =>
  await getCall({ path: `/leave-request/team${status ? `?status=${status}` : ""}` });
